import type { User } from 'src/services/apollo/generated/graphql'

export function userHasMembership(
  user?: User | { membership?: User['membership'] },
) {
  return user?.membership?.tier != null
}

/**
 * @see packages/pixai-server/src/service/userSubscription.ts
 */
export const UserSubscriptionStatus = {
  active: 'active',
  canceled: 'canceled',
  pending: 'pending',
  inactive: 'inactive',
} as const
